module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.0.3.0.box.56.1632.1314.800.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.1.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP3"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 2",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.5.0.0.box.40.150.1507.2248.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0003.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.3.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP7"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 6",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP2.w.0.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP8"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "Image for page 7",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.0.0.box.383.640.816.189.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.0.0.box.766.640.55.38.q.70"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.8.0.1.box.383.702.816.47.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP3.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP3.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP4.w.0.0.0"
    }
  }), _vm._v("My Wife, Laura McClos"), _c('a', {
    attrs: {
      "id": "GBS.PP5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP5.w.0.0.0"
    }
  }), _vm._v("key Clement.")]), _c('a', {
    attrs: {
      "id": "GBS.PP6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.1.0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.0.1.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP6.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "right",
      "margin-right": "2em"
    },
    attrs: {
      "id": "para.8.0.2.box.968.791.230.38.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.0.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.2.0.0"
    }
  }), _vm._v("—W. E. C.")]), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.4.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PP7.w.4.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP8.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP8.w.1.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.0.1.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.1.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.2.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.3.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.4.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.5.0.0"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PP11"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP11.w.6.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.7.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.8.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.9.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP11.w.9.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58b6aaf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0006.vue
// module id = 54
// module chunks = 0